import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';

import { StorageService } from 'core/services';
import { StorageKeys } from 'core/enums/storage-keys';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  const storageService = inject(StorageService);
  const token = storageService.getItemFromSessionStorage(StorageKeys.AccessToken);
  const language = storageService.getItemFromLocalStorage(StorageKeys.CurrentLanguage);

  // AUTHENTICATION DISABLED FOR TESTING - Make Authorization header optional
  const headers: any = {
    'Access-Control-Allow-Origin': '*',
    'Cache-Control': 'no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
    'Accept-Language': `${language || 'en'}`
  };

  // Only add Authorization header if token exists (optional for testing)
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }

  req = req.clone({
    setHeaders: headers
  });

  return next(req);
};
